/* global angular, moment */
/**
 * Created by lari on 26/04/2017.
 */
(function () {
  'use strict';
  angular.module('vcexam')
    .component('exameditor', {
      restrict: 'E',
      bindings: {
        exam: '='
      },
      templateUrl: 'vcexam/exameditor-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'vertxEventBusService', '$window', 'ExamHelper', 'Rlog', 'PrintHelper', '$http', '$timeout',
        function ($log, vertxEventBusService, $window, ExamHelper, Rlog, PrintHelper, $http, $timeout) {
          let vm = this;
          vm.save = save;
          vm.addBiopsyField = addBiopsyField;
          vm.printBiopsyLabels = printBiopsyLabels;
          vm.finishExam = ExamHelper.finishExam;
          vm.clearDoctor = clearDoctor;
          vm.saveDoctor = saveDoctor;
          vm.previewUrl = PrintHelper.examPreviewUrl(vm.exam._id, vm.exam.consultid);
          vm.addTrackerValue = addTrackerValue;

          function save() {
            $log.debug('[EXAM][ExamEditor] save called');
            vm.exam.$save();
          }

          function addBiopsyField() {
            let biopsy = {
              label: '',
              avalues: [],
              values: []
            };
            vm.exam.template.biopsy.biopsies.push(biopsy);
            $log.debug('[EXAM][ExamEditor] Biospies: ', vm.exam.template.biopsy.biopsies);
          }

          function printBiopsyLabels() {
            if (vm.exam.$hasPendingActions) {
              $log.warn('[EXAM][ExamEditor] exam save had pending actions, cancelling now.');
              vm.exam.$cancel();
              $timeout(function () {
                $log.warn('[EXAM][ExamEditor]  waited 1.5 seconds because of consult having had pending actions, saving now.');
                reallyPrint();
              }, 1500);
            } else {
              reallyPrint();
            }
          }

          // /routes/fop/exam/false/false/58f8820cb148b776e918dd0e/58f88208b148b776e918dd0d
          function reallyPrint() {
            $http({
              url: `/routes/fop/examlabels/true/true/${vm.exam._id}`,
              method: 'GET'
            }).success(function () {
              vm.labelsprinted = true;
            }).error(function () {
              vm.labelsprinted = false;
            });
          }

          function saveDoctor(doctor) {
            vm.exam.template.biopsy.pathology = doctor;
            vm.save();
          }


          function clearDoctor() {
            delete vm.exam.template.biopsy.pathology;
            /*            if (vm.newref && vm.newref.doctor) {
                          delete vm.newref.doctor;
                        }*/
          }


          function addTrackerValue(trackervalue) {
            $log.debug('exam editor addTrackervalue called for: ', trackervalue);
            if (angular.isUndefined(vm.exam.template.trackervalues)) {
              vm.exam.template.trackervalues = {};
            }
            // reminder: prefixing 'v' is necessary because numberonly string can not be converted into xml tags
            if (angular.isUndefined(vm.exam.template.trackervalues['v' + trackervalue.trackerid])) {
              vm.exam.template.trackervalues['v' + trackervalue.trackerid] = {name: trackervalue.name, entries: []};
            }
            vm.exam.template.trackervalues['v' + trackervalue.trackerid].entries.push(trackervalue.def);
            vm.save();
          }

          
          const examsUpdateHandler = function (message) {
            let messages = message.split(':');
            // only refresh exam if change was NOT triggered by this browser
            if (angular.isDefined(vm.exam) && messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.exam._id === messages[0]) {
              vm.exam.$refresh();
              $log.debug('(exameditor) refreshed openexam');
            }
            else {
              $log.debug(' (exameditor) ignored openexam change');
            }
          };

          $log.debug('[Vert.x subscribe] examinations.update');
          vertxEventBusService.on('examinations.update', {}, examsUpdateHandler);

          vm.$onDestroy = function () {
            $log.debug('[Vert.x unsubscribe] examinations.update');
            vertxEventBusService.unregisterHandler('examinations.update', {}, examsUpdateHandler);
          };


          vm.sprref = `Überweisungen für abgeschlossene Untersuchungen können Sie in der Überweisungsansicht der
                       Konsultation einsehen und editieren. Änderungen an Biospiefeldern, die Sie nach Abschluß der
                       Untersuchung vornehmen, werden NICHT automatisch in bestehende Überweisungen übernommen.`;

        }] // controller
    }); // component

// klammerfriedhof
}());